import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PromoTypeEnum } from 'app/models';
import * as moment from 'moment';
import {ServiceTypePromotionsComponent} from 'app/service-type';
import { PromoStatus } from 'app/models/enums/promo-status.enum';

@Component({
    selector: 'service-type-promotion-filter',
    templateUrl: './service-type-promotion-filter.component.html',
    styleUrls: ['./service-type-promotion-filter.component.scss']
})
export class ServiceTypePromotionFilterComponent implements OnInit {

    @Input()
    public visiblePartnerMarketingFilterPromotion: boolean = false;

    @Input() serviceTypePromotionsComponent!: ServiceTypePromotionsComponent;

    public filterObj: any = {};
    @Input()
    set _filterObj(obj: any) {
        this.filterObj = obj;
        if (this.filterObj.StartedAt) {
            this.filterObj.StartedAt = new Date(this.filterObj.StartedAt);
        }
        if (this.filterObj.ValidUntil) {
            this.filterObj.ValidUntil = new Date(this.filterObj.ValidUntil);
        }
    }

    @Output() changedShowPartnerMarketingFilterPromotionSideBarEmit = new EventEmitter<boolean>();
    changedShowPartnerMarketingFilterPromotionSideBar(increased: boolean) {
        this.changedShowPartnerMarketingFilterPromotionSideBarEmit.emit(increased);
    }

    constructor() { }

    public promoTypeEnum = PromoTypeEnum;

    ngOnInit(): void {}

    public clickStatus(status: string) {
        this.filterObj.Status = status;
    }

    public uncheckFilter() {
        this.filterObj = {};
    }

    public clickFilter() {
        this.filterObj.PromoTypeId = +this.filterObj.PromoTypeId;
        if (this.filterObj.StartedAt) {
            this.filterObj.StartedAt = moment(this.filterObj.StartedAt).format('YYYY-MM-DD');
        }
        if (this.filterObj.ValidUntil) {
            this.filterObj.ValidUntil = moment(this.filterObj.ValidUntil).format('YYYY-MM-DD');
        }
        this.serviceTypePromotionsComponent.getPromos(0, this.filterObj);
        this.cancel();
    }

    public cancel() {
        this.changedShowPartnerMarketingFilterPromotionSideBar(false);
    }

    protected readonly PromoStatus = PromoStatus;
}
